import { render, staticRenderFns } from "./rejectOrder.vue?vue&type=template&id=11a01147&scoped=true&"
import script from "./rejectOrder.vue?vue&type=script&lang=js&"
export * from "./rejectOrder.vue?vue&type=script&lang=js&"
import style0 from "./rejectOrder.vue?vue&type=style&index=0&id=11a01147&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a01147",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDialog,VSpacer})
